import { Layout, Typography } from 'antd'
import styled from 'styled-components/macro'

export const AuthPageLayout = styled(Layout)`
  min-height: 100vh !important;
  position: relative;
  overflow: hidden;
  background: transparent;

  .ant-typography-danger {
    display: block;
    text-align: center;
    margin-top: 10px;
  }

  .ant-layout-content {
    background: transparent !important;
  }

  main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    z-index: 1;
  }

  .ant-form-item-children {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
`

export const AuthBackdrop = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background: radial-gradient(
      820px 520px at 18% 22%,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0.06) 44%,
      rgba(255, 255, 255, 0) 74%
    ),
    radial-gradient(
      940px 560px at 86% 82%,
      rgba(19, 45, 7, 0.2) 0%,
      rgba(19, 45, 7, 0.08) 42%,
      rgba(19, 45, 7, 0) 72%
    ),
    linear-gradient(155deg, #9fbf39 0%, #86a533 48%, #5e7b2b 100%);

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: min(72vw, 620px);
    height: min(62vh, 470px);
    transform: translate(-50%, -42%);
    border-radius: 999px;
    background: radial-gradient(
      closest-side,
      rgba(255, 255, 255, 0.22) 0%,
      rgba(255, 255, 255, 0.1) 36%,
      rgba(255, 255, 255, 0.03) 58%,
      rgba(255, 255, 255, 0) 78%
    );
    filter: blur(14px);
  }

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: min(62vw, 540px);
    height: min(52vh, 390px);
    transform: translate(-50%, -44%);
    border-radius: 999px;
    background: radial-gradient(
      closest-side,
      rgba(255, 255, 255, 0.14) 0%,
      rgba(255, 255, 255, 0.06) 42%,
      rgba(255, 255, 255, 0) 72%
    );
    filter: blur(10px);
  }
`

export const AuthSurface = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.975);
  padding: 28px 24px 24px;
  border-radius: 14px;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.4),
    0 26px 58px rgba(8, 20, 12, 0.3), 0 10px 24px rgba(8, 20, 12, 0.18);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 12px;
    right: 12px;
    height: 2px;
    border-radius: 0 0 999px 999px;
    background: linear-gradient(
      90deg,
      rgba(19, 45, 7, 0.18),
      rgba(180, 216, 32, 0.65),
      rgba(19, 45, 7, 0.18)
    );
  }
`

export const AuthLogo = styled.img`
  display: block;
  width: 112px;
  margin: 0 0 20px;
`

export const AuthHeading = styled(Typography.Title)`
  && {
    margin-bottom: 4px;
    font-size: 1.7rem;
    line-height: 1.2;
    font-weight: 700;
    color: ${({ theme }) => theme.colours.bbqBlack};
  }
`

export const AuthSubheading = styled(Typography.Text)`
  display: block;
  margin-bottom: 18px;
  color: #4f4f4f;
  font-size: 0.9rem;
  line-height: 1.5;
`

export const AuthTrustText = styled(Typography.Text)`
  display: block;
  margin-top: 16px;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  color: #5f5f5f;
`
